var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('Form',{attrs:{"type":"login","error":_vm.error},on:{"submited":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }